<template>
    <div>
        <div class="action-table-web" v-if="$detect == 'web'">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-4">
                            <ldc-select
                                v-model="data.type"
                                filterable
                                placeholder="Chọn dạng bài viết">
                                <ldc-option
                                    v-for="(item, index) in categories" :key="index"
                                    :value="item.id"
                                    :label="item.name"/>
                            </ldc-select>
                        </div>
                        <div class="col-6">
                            <div class="search position-relative">
                                <input type="text" class="w-100 bg-white fs-14px" placeholder="Nhập #id hoặc tiêu đề tin"
                                       v-model="keyword" @keyup.enter="enterKeyword()"/>
                                <div class="btn-search position-absolute">
                                    <span class="lable-search px-10px" @click="enterKeyword()">
                                        <i class="icon ion-ios-search fs-20px"></i>
                                    </span>
                                </div>
                                <div class="text-warning-search fs-10px position-absolute">
                                    * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> )
                                </div>
                            </div>
                        </div>
                        <div class="col-2">
                            <button class="btn btn-block border-0 fs-14px btn-cancel-filter" style="height: 35px;"
                                    @click="removeFillter()">Bỏ lọc</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="action-table-mobile">
                <div input-search>
                    <div content-input-search class="search-box position-relative">
                        <input type="text" placeholder="Nhập id hoặc tiêu đề tin"
                               v-model="keyword" @keyup.enter="enterKeyword()"/>
                        <div class="text-warning-search fs-10px"> * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> ) </div>
                    </div>
                </div>
                <div class="d-flex mb-10px">
                    <div class="w-50 pl-1">
                        <button type="button" class="btn btn-primary time-date btn-block bg-white fs-14px pl-10px"
                                @click="fillterMobile = true">
                            <i class="icon ion-ios-options fs-18px mr-2"></i>Lọc nâng cao
                        </button>
                    </div>
                </div>
            </div>
            <ldc-model-mobile
                titileCancel="Hủy"
                :showCancel="false"
                :showTitle="true"
                title="Lọc bài viết"
                :customButton="true"
                :visible.sync="fillterMobile">
                <div slot="content-model"
                     :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div class="item-fillter" role="button">
                        <ldc-select-mobile
                            placeholder="Chọn bài viết"
                            title="Lọc theo bài viết"
                            v-model="data.category">
                            <ldc-option-mobile
                                v-for="(item, index) in categories" :key="index"
                                :value="item.id"
                                :label="item.name"/>
                        </ldc-select-mobile>
                    </div>
                </div>
                <div slot="custom-buttom"
                     :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div :class="{
                        'btn-confirm-android': $isAndroid,
                        'btn-confirm-ios mb-10px': !$isAndroid
                        }">
                        <button class="btn btn-primary radius-ios text-uppercase mr-10px fs-14px btn-apply"
                                @click="emitModel()" close-model-mobile>áp dụng</button>
                        <button class="btn btn-light radius-ios text-uppercase ml-10px fs-14px btn-cancel"
                                @click="removeFillter()" close-model-mobile>Bỏ lọc</button>
                    </div>
                </div>
            </ldc-model-mobile>
        </div>
        <actionDialog
            :multiple="true"
            :action="action"
            :visible.sync="dialog"
            :dataMultiple="idSelect"/>
    </div>
</template>
<script>
export default {
    props: ['value', 'idSelect'],
    components: {
        actionDialog: () => import('@/components/profile/raovat/actionDialog.vue'),
    },
    data(){
        return {
            categories: [],
            fillters: [],
            data: {
                type: this.$route.query.type ? this.$route.query.type*1 : '',
            },
            keyword: this.$route.query.keyword,
            showTime: false,
            showActionMuti: false,
            fillterMobile: false,
            dialog: false,
            action: '',
            showFilterDate: false,
            loading: false,
        }
    },
    watch: {
        data:{
            handler(val){
                if(this.$detect == 'web'){
                    this.emitModel();
                }
            },
            deep: true,
        },
        value: {
            handler(val){
                this.changeValue();
            },
            deep: true,
        }
    },
    created() {
        this.changeValue();
        apiGet('/v2/profile/static-params').then(res => {
            this.categories = res;
        })
    },
    methods: {
        changeValue(){
            this.data.type = this.value.type ? this.value.type : '';
            this.keyword = this.value.keyword ? this.value.keyword : '';
        },
        enterKeyword(){
            if(this.keyword.length < 3 && this.keyword.length > 0) return;
            this.emitModel();
        },
        emitModel(){
            let data = {
                type: this.data.type,
                keyword: this.keyword
            }
            if(this.data.page) data.page = this.data.page;
            this.$emit('input', data)
        },

        async destroy(){
            this.loading = true;
            this.loading = false;
        },

        removeFillter(){
            this.data = {
                type: '',
            }
            this.keyword = '';
            this.emitModel();
        },
    },
}
</script>
